import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { SetCurrentElementId } from 'src/app/shared/store/shared.actions';
import * as AgentActions from '../../store/agents.actions';
import {
  trigger,
  style,
  transition,
  animate,
} from '@angular/animations';
import { IAgent } from '../../models/agents.models';
import * as AgentSelectors from '../../store/agents.selectors';
import {
  distinctUntilChanged,
  filter,
  Observable,
  Subject,
  takeUntil,
} from 'rxjs';
import { CatalogsService } from 'src/app/features/catalogs/services/catalogs.services';

@Component({
  selector: 'app-agent-details',
  templateUrl: './agent-details.component.html',
  styleUrls: ['./agent-details.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(40px)' }),
        animate('250ms cubic-bezier(0.4,0,0.2,1)', style({ opacity: 1, transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        animate('200ms cubic-bezier(0.4,0,0.2,1)', style({ opacity: 0, transform: 'translateX(-40px)' }))
      ]),
    ]),
  ],
})
export class AgentDetailsComponent implements OnInit {
  agentId!: number;
  agent$: Observable<IAgent | null> = this.store.select(
    AgentSelectors.selectAgent
  );
  agent: IAgent | null = null;

  leftPanelActiveTab: 'orders' | 'portfolio' | 'catalogs' = 'orders';
  rightPanelActiveTab: 'details' | 'contract' = 'details';

  active_date_filter: 'year_to_date' | 'last_year' = 'year_to_date';

  showDeleteButton: boolean = false;
  triggerAddPortfolio: boolean = false;
  triggerDeletePortfolio: boolean = false;
  triggerAddCatalogs: boolean = false;
  isCurrentMonthExpanded: boolean = true;

  destroy$ = new Subject<void>();

  constructor(
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private catalogService: CatalogsService
  ) {}

  ngOnInit(): void {
    this.agentId = +this.activatedRoute.snapshot.paramMap.get('id')!;
    this.store.dispatch(AgentActions.GetAgentById({ id: this.agentId }));
    this.store.dispatch(
      SetCurrentElementId({ currentElementId: this.agentId })
    );

    this.agent$
      .pipe(
        filter((agent) => agent != null),
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      )
      .subscribe((agent: IAgent | null) => {
        if (agent) {
          this.agent = agent;
        }
      });
  }

  get totalLocations() {
    return this.agent?.companies_ids?.reduce((total, company) => total + company.nbr_locations_with_agent!, 0) || 0;
  }

  onSelectedLocationsChanged(hasSelection: boolean) {
    this.showDeleteButton = hasSelection;
  }

  onDeleteLocations() {
    this.triggerDeletePortfolio = true;
    // Reset after triggering so it can be triggered again
    setTimeout(() => this.triggerDeletePortfolio = false, 0);
  }

  onAddPortfolio() {
    this.triggerAddPortfolio = true;
    setTimeout(() => this.triggerAddPortfolio = false, 0);
  }

  onAddCatalogs() {
    this.triggerAddCatalogs = true;
    setTimeout(() => this.triggerAddCatalogs = false, 0);
  }

  onDateFilterChanged(dates: { start_date: string, end_date: string, filter: 'year_to_date' | 'last_year' }) {
    this.active_date_filter = dates.filter;
    this.store.dispatch(AgentActions.GetAgentById({ id: this.agentId, params: { start_date: dates.start_date, end_date: dates.end_date } }));
  }

  goToNewCatalog(): void {
    // Clear old new catalog saved data
    this.catalogService.setNewCatalogData(null)
    this.router.navigate(['/agents/new-catalog'], { queryParams: { agentId: this.agentId } });
  }

  goBack(): void {
    this.router.navigate(['/agents']);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.store.dispatch(AgentActions.ClearAgent());
  }
}
